<template>
	<div>
		<div class="main-contents">
			<div class="contents">
				<div class="contents_body">
					<div class="tit">
						<span>회원탈퇴</span><br/>
						탈퇴를 위해 비밀번호를 다시 입력해주세요.
					</div>
				</div>
			</div>
			<div class="mem_container">
				<div class="main-box">				
					<div class="mem_contents_body">
						<div class="info-box">
							<div class="contents-body-box">
								<p class="mb-10">회원 탈퇴</p>
								<div class="mem-id-input" style="margin-right: 110px">
									<div class="pwbox">
										<span class="vital">*</span><span>비밀번호 확인</span>
										<input type="password" id="txt_pw02" v-model="mberInfo.passwordCfm" ref="passwordCfm" placeholder="비밀번호 확인" />
									</div>
								</div>
								<div class="confirm-btn" @click="rejectMber()">
									회원 탈퇴
								</div>
							</div>
						</div>
					</div>
				</div>				
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			mberInfo : {
				id : '',
				password : '',
				passwordCfm : ''
			},
			pwdSamePass : false,
			alert : false
		}
	},

	beforeMount() {
		if(this.$route.params) {
			this.mberInfo.id = this.$route.params.id;
			this.mberInfo.password = this.$route.params.password;
		}
	},

	methods : {
		rejectMber() {

			if(!this.mberInfo.passwordCfm) {
				alert('비밀번호 확인을 입력하세요.');
				this.$refs.passwordCfm.focus();
				return false;
			}

			if(this.mberInfo.password != this.mberInfo.passwordCfm) {
				alert('비밀번호가 일치하지 않습니다.');
				return false;
			}

			// 비밀번호 형식 체크 
			const passTest = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[`~!@#$%^&*()_+=-]).{8,16}$/;
			var passRes = passTest.test(this.mberInfo.password);
			if(!passRes) {
				alert("비밀번호는 8~16자의 영문 / 숫자 / 특수문자를 모두 사용해야합니다.");
				return false;
			}

			this.$.httpPost('/api/mem/rejectMberWithdrawal', this.mberInfo)
				.then(res => {
					if(res.data.resultCode == '000') {
						this.btnClose();
					}
				})
				.catch(err => {
					alert('ERROR :', err.message);
				});
		},

		btnClose() {
			this.$.popup('/mem/MEM001P07')
                .then(res => {
                    if(res) {
						this.$router.push({name : 'MEM005M01'});
                    }
                });
		}
	}
}
</script>